import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1316bdce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail-title" }
const _hoisted_2 = { class: "detail-content" }
const _hoisted_3 = {
  class: "flex-cen",
  style: {"margin-top":"20px"}
}

import { t } from '@/plugins/i18n'
import { ref, reactive } from 'vue'
import { getJapanTime } from '@/util/common'
import TempA from './TempA.vue'
import TempB from './TempB.vue'
import TempC from './TempC.vue'
import TempD from './TempD.vue'
import TempE from './TempE.vue'
import TempF from './TempF.vue'
import TempG from './TempG.vue'
import TempH from './TempH.vue'
import TempI from './TempI.vue'
import TempJ from './TempJ.vue'
import TempK from './TempK.vue'
import TempL from './TempL.vue'
import TempM from './TempM.vue'
import TempN from './TempN.vue'
import TempO from './TempO.vue'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  rowItem: {
    type: Object,
    default: () => ({})
  },
  rowItemDetail: {
    type: Object,
    default: () => ({})
  },
  dict: {
    type: Object,
    default: () => ({})
  }
},
  emits: ['update:visible'],
  setup(__props, { emit }) {



const columns = [
  { prop: 'porductSku', label: t('平台商品SKU') },
  { prop: 'productInfo', label: t('规格') },
  { prop: 'productInfo', label: t('商品信息') },
  { prop: 'price', label: t('销售单价') },
  { prop: 'num', label: t('结算数量') },
  { prop: 'allPrice', label: t('结算总价') }
]

const data: any[] = [
  {
    id: '1',
    porductSku: '',
    productInfo: '',
    price: '',
    allPrice: 5,
    createTime: '2011-01-01'
  },
  {
    id: '1',
    porductSku: '',
    productInfo: '',
    price: '',
    allPrice: 5,
    createTime: '2011-01-01'
  },
  {
    id: '1',
    porductSku: '',
    productInfo: '',
    price: '',
    allPrice: 5,
    createTime: '2011-01-01'
  }
]




return (_ctx: any,_cache: any) => {
  const _component_temp_p = _resolveComponent("temp-p")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "destroy-on-close": "",
    "model-value": __props.visible,
    "custom-class": "a-detail-f flex",
    onClose: _cache[1] || (_cache[1] = ($event: any) => (emit('update:visible', false)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('详情')), 1),
      _createElementVNode("div", _hoisted_2, [
        (__props.rowItem.fundFlowType === 3)
          ? (_openBlock(), _createBlock(TempA, {
              key: 0,
              rowName: __props.rowItem.fundFlowTypeName,
              rowItemDetail: __props.rowItemDetail
            }, null, 8, ["rowName", "rowItemDetail"]))
          : _createCommentVNode("", true),
        (__props.rowItem.fundFlowType === 4)
          ? (_openBlock(), _createBlock(TempB, {
              key: 1,
              rowName: __props.rowItem.fundFlowTypeName,
              rowItemDetail: __props.rowItemDetail
            }, null, 8, ["rowName", "rowItemDetail"]))
          : _createCommentVNode("", true),
        (__props.rowItem.fundFlowType === 5)
          ? (_openBlock(), _createBlock(TempC, {
              key: 2,
              rowName: __props.rowItem.fundFlowTypeName,
              rowItemDetail: __props.rowItemDetail
            }, null, 8, ["rowName", "rowItemDetail"]))
          : _createCommentVNode("", true),
        (__props.rowItem.fundFlowType === 6)
          ? (_openBlock(), _createBlock(TempG, {
              key: 3,
              rowName: __props.rowItem.fundFlowTypeName,
              rowItemDetail: __props.rowItemDetail
            }, null, 8, ["rowName", "rowItemDetail"]))
          : _createCommentVNode("", true),
        (__props.rowItem.fundFlowType === 8 || __props.rowItem.fundFlowType === 28)
          ? (_openBlock(), _createBlock(TempF, {
              key: 4,
              rowName: __props.rowItem.fundFlowTypeName,
              rowItemDetail: __props.rowItemDetail,
              type: 1
            }, null, 8, ["rowName", "rowItemDetail"]))
          : _createCommentVNode("", true),
        (__props.rowItem.fundFlowType === 9)
          ? (_openBlock(), _createBlock(TempF, {
              key: 5,
              rowName: __props.rowItem.fundFlowTypeName,
              rowItemDetail: __props.rowItemDetail,
              type: 2
            }, null, 8, ["rowName", "rowItemDetail"]))
          : _createCommentVNode("", true),
        (__props.rowItem.fundFlowType === 13)
          ? (_openBlock(), _createBlock(TempD, {
              key: 6,
              rowName: __props.rowItem.fundFlowTypeName,
              rowItemDetail: __props.rowItemDetail
            }, null, 8, ["rowName", "rowItemDetail"]))
          : _createCommentVNode("", true),
        (__props.rowItem.fundFlowType === 14)
          ? (_openBlock(), _createBlock(TempE, {
              key: 7,
              rowName: __props.rowItem.fundFlowTypeName,
              rowItemDetail: __props.rowItemDetail
            }, null, 8, ["rowName", "rowItemDetail"]))
          : _createCommentVNode("", true),
        (__props.rowItem.fundFlowType === 15)
          ? (_openBlock(), _createBlock(TempH, {
              key: 8,
              rowName: __props.rowItem.fundFlowTypeName,
              rowItemDetail: __props.rowItemDetail
            }, null, 8, ["rowName", "rowItemDetail"]))
          : _createCommentVNode("", true),
        (__props.rowItem.fundFlowType === 16)
          ? (_openBlock(), _createBlock(TempI, {
              key: 9,
              rowName: __props.rowItem.fundFlowTypeName,
              rowItemDetail: __props.rowItemDetail
            }, null, 8, ["rowName", "rowItemDetail"]))
          : _createCommentVNode("", true),
        (__props.rowItem.fundFlowType === 18)
          ? (_openBlock(), _createBlock(TempJ, {
              key: 10,
              rowName: __props.rowItem.fundFlowTypeName,
              rowItemDetail: __props.rowItemDetail
            }, null, 8, ["rowName", "rowItemDetail"]))
          : _createCommentVNode("", true),
        (__props.rowItem.fundFlowType === 24)
          ? (_openBlock(), _createBlock(TempK, {
              key: 11,
              rowName: __props.rowItem.fundFlowTypeName,
              rowItemDetail: __props.rowItemDetail
            }, null, 8, ["rowName", "rowItemDetail"]))
          : _createCommentVNode("", true),
        (__props.rowItem.fundFlowType === 27 || __props.rowItem.fundFlowType === 67)
          ? (_openBlock(), _createBlock(TempL, {
              key: 12,
              rowName: __props.rowItem.fundFlowTypeName,
              rowItemDetail: __props.rowItemDetail
            }, null, 8, ["rowName", "rowItemDetail"]))
          : _createCommentVNode("", true),
        (__props.rowItem.fundFlowType === 29)
          ? (_openBlock(), _createBlock(TempM, {
              key: 13,
              rowName: __props.rowItem.fundFlowTypeName,
              rowItemDetail: __props.rowItemDetail
            }, null, 8, ["rowName", "rowItemDetail"]))
          : _createCommentVNode("", true),
        (__props.rowItem.fundFlowType === 36)
          ? (_openBlock(), _createBlock(TempN, {
              key: 14,
              rowName: __props.rowItem.fundFlowTypeName,
              rowItemDetail: __props.rowItemDetail
            }, null, 8, ["rowName", "rowItemDetail"]))
          : _createCommentVNode("", true),
        (__props.rowItem.fundFlowType === 37)
          ? (_openBlock(), _createBlock(TempO, {
              key: 15,
              rowName: __props.rowItem.fundFlowTypeName,
              rowItemDetail: __props.rowItemDetail
            }, null, 8, ["rowName", "rowItemDetail"]))
          : _createCommentVNode("", true),
        (__props.rowItem.fundFlowType === 38)
          ? (_openBlock(), _createBlock(_component_temp_p, {
              key: 16,
              rowName: __props.rowItem.fundFlowTypeName,
              rowItemDetail: __props.rowItemDetail
            }, null, 8, ["rowName", "rowItemDetail"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:visible', false)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('我知道了')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})